import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFiles: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"files, documents"} maskId="square-filled-radius-0-stroke-1-IconFiles"><path fillRule="evenodd" clipRule="evenodd" d="M7 5H4V22H18V19H21V8H15V2H7V5ZM7 6V19H17V21H5V6H7Z" fill="currentColor"/><path d="M16 2.29289L20.7071 7H16V2.29289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFiles;
